import { transition } from '@helpers/animate';
import { imageCoverContainer } from '@helpers/aspectRatio';
import brand from '@helpers/brand';
import { Device, from, until } from '@helpers/media';
import { h3, paragraphRegular } from '@helpers/typography';
import styled from 'styled-components';
const Container = styled.div `
  display: block;
  padding: 0;
  position: relative;
  color: ${brand.white};
  height: 338px;
  width: 100%;
  border: none;
  overflow: hidden;
  cursor: pointer;

  &.focus-ring {
    outline: auto;
    outline-color: currentColor;
    outline-offset: 5px;
    outline-width: thin;
  }

  @media ${from(Device.TabletSmall)} {
    height: 500px;
  }

  &[data-card-size='small'] {
    height: 200px;

    @media ${from(Device.TabletSmall)} {
      height: 500px;
    }
  }
`;
const Overlay = styled.div `
  position: absolute;
  left: 0;
  bottom: 0;
  z-index: 1;
  height: 203px;
  width: 100%;
  background: linear-gradient(0deg, rgba(0, 0, 0, 0.5) 0%, rgba(255, 255, 255, 0) 75%);

  @media ${from(Device.TabletSmall)} {
    height: 300px;
  }
`;
const ContentArea = styled.div `
  position: absolute;
  bottom: 32px;
  left: 16px;
  z-index: 2;
  display: flex;
  flex-direction: column;

  &[data-has-date='false'] {
    padding-right: 60px;
  }

  @media ${until(Device.Tablet)} {
    bottom: 24px;
    left: 12px;
  }
`;
const Title = styled.h3 `
  ${h3};
  text-align: left;
  margin-bottom: 10px;
  position: relative;
  padding-bottom: 0;
  margin-bottom: 0;
`;
const Subtitle = styled.p `
  ${paragraphRegular};
  margin-bottom: 0;
  margin-top: 16px;
  text-align: left;

  @media ${until(Device.Tablet)} {
    margin-top: 14px;
  }

  @media ${until(Device.TabletSmall)} {
    display: none;
  }
`;
const Date = styled.time `
  ${paragraphRegular};
  margin-bottom: 0;
  margin-top: 16px;

  ${ContentArea}[data-has-date="true"] & {
    padding-right: 60px;
  }

  @media ${until(Device.Tablet)} {
    margin-top: 14px;
  }
`;
const MediaArea = styled.div `
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
`;
const Image = styled.img `
  ${imageCoverContainer()};
  ${transition('transform')}

  @media ${from(Device.DesktopSmall)} {
    ${Container}:hover & {
      transform: scale(1.03);
    }
  }
`;
const IconHolder = styled.div `
  position: absolute;
  width: 35px;
  height: 35px;
  border-radius: 100%;
  border: 1px solid ${brand.primary.beige};
  bottom: 24px;
  right: 16px;
  color: ${brand.primary.beige};
  ${transition('background-color, color')};
  overflow: hidden;
  z-index: 2;

  @media ${until(Device.Tablet)} {
    bottom: 16px;
    right: 12px;
  }

  svg {
    transform-origin: 50% 50%;
    transform: scale(1.1);
  }

  @media ${from(Device.DesktopSmall)} {
    ${Container}:hover & {
      color: ${brand.black};
      background-color: ${brand.primary.beige};
    }
  }
`;
const CarouselCardStyles = {
    Container,
    ContentArea,
    Date,
    IconHolder,
    Image,
    MediaArea,
    Overlay,
    Subtitle,
    Title,
};
export default CarouselCardStyles;
